import RestResource from "@/api/rest/rest-resource";
import {athubAxios} from "@/util";
import {ORGANIZATION_SERVER} from "@/api";

const userGroupUser = new RestResource({server: ORGANIZATION_SERVER, resource: 'userGroupUser'});

userGroupUser.batchAdd = (userGroupUsers) => {
    let userId = userGroupUsers[0].userId;
    let groupIds = userGroupUsers.map(e => e.userGroupId);
    let url = `${ORGANIZATION_SERVER}/userGroupUser/bind/userid/${userId}`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, groupIds).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

userGroupUser.batchDelete = (userGroupUsers) => {
    let userId = userGroupUsers[0].user.id;
    let groupIds = userGroupUsers.map(e => e.group.id);
    let url = `${ORGANIZATION_SERVER}/userGroupUser/unbind/userid/${userId}`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, groupIds).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default userGroupUser;